
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4gvO2Heta5wQSyDTxvBhQ3SfFZ8ByX8Xv1ebh14cQJUMeta } from "/home/rizoa/workd/project-2025/AIMI/NEWAgen/dashboard:client/pages/index.vue?macro=true";
import { default as labsI1h3RVdRJA7XlXMaXH_45_45CWJnNaUs9Ys_45OkrzSBAq8E0Meta } from "/home/rizoa/workd/project-2025/AIMI/NEWAgen/node_modules/.c12/gitlab_ikamai_nuxt_y3SYUSEha/pages/_labs/labs.vue?macro=true";
import { default as JsonEditorPage8Om_45LIDtC9O7MHN337Tkf22GE5YxWRT_45Q8oznPVpjxkMeta } from "/home/rizoa/workd/project-2025/AIMI/NEWAgen/node_modules/.c12/gitlab_ikamai_nuxt_y3SYUSEha/pages/_labs/JsonEditorPage.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/rizoa/workd/project-2025/AIMI/NEWAgen/dashboard:client/pages/index.vue")
  },
  {
    name: "_labs-labs",
    path: "/_labs/labs",
    meta: labsI1h3RVdRJA7XlXMaXH_45_45CWJnNaUs9Ys_45OkrzSBAq8E0Meta || {},
    component: () => import("/home/rizoa/workd/project-2025/AIMI/NEWAgen/node_modules/.c12/gitlab_ikamai_nuxt_y3SYUSEha/pages/_labs/labs.vue")
  },
  {
    name: "_labs-JsonEditorPage",
    path: "/_labs/JsonEditorPage",
    component: () => import("/home/rizoa/workd/project-2025/AIMI/NEWAgen/node_modules/.c12/gitlab_ikamai_nuxt_y3SYUSEha/pages/_labs/JsonEditorPage.vue")
  }
]